import { useEffect, useRef } from "react";
import confirm from "../components/Modals/Confirm";
import { useLocation, useNavigationType } from "react-router-dom";

export const PolicyTxt: string = `
제 1 장 총칙
제 1 조 (목적)
본 약관은 기업마당 사이트가 제공하는 모든 서비스(이하 “서비스”)의 이용조건 및 절차, 이용자와 기업마당 사이트의 권리, 의무, 책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.

제 2 조 (약관의 효력과 변경)
기업마당 사이트는 귀하가 본 약관 내용에 동의하는 경우 기업마당 사이트의 서비스 제공 행위 및 귀하의 서비스 사용 행위에 본 약관이 우선적으로 적용됩니다.
기업마당 사이트는 본 약관을 사전 고지 없이 변경할 수 있고 변경된 약관은 기업마당 사이트 내에 공지하거나 e-mail을 통해 회원에게 공지하며, 공지와 동시에 그 효력이 발생됩니다.
이용자가 변경된 약관에 동의하지 않는 경우, 이용자는 본인의 회원등록을 취소 (회원탈락)할 수 있으며 계속 사용의 경우는 약관 변경에 대한 동의로 간주 됩니다.

제 3 조 (약관 외 준칙)
본 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법, 정보통신윤리위원회심의규정, 정보통신 윤리강령, 프로그램보호법 및 기타 관련 법령의 규정에 의합니다.

제 4 조 (용어의 정의)
본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
이용자 : 본 약관에 따라 기업마당 사이트가 제공하는 서비스를 받는 자.
가입 : 기업마당 사이트가 제공하는 신청서 양식에 해당 정보를 기입하고, 본 약관에 동의하여 서비스 이용계약을 완료시키는 행위.
회원 : 기업마당 사이트에 개인 정보를 제공하여 회원 등록을 한 자로서 기업마당 사이트가 제공하는 서비스를 이용할 수 있는 자.
비밀번호 : 이용자와 회원ID가 일치하는지를 확인하고 통신상의 자신의 비밀보호를 위하여 이용자 자신이 선정한 문자와 숫자의 조합.
탈퇴 : 회원이 이용계약을 종료시키는 행위.
제 2 장 서비스 제공 및 이용
제 5 조 (이용계약의 성립)
본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
이용계약은 신청자가 온라인으로 기업마당 사이트에서 제공하는 소정의 가입신청 양식에서 요구하는 사항을 기록하여 가입을 완료하는 것으로 성립됩니다.
기업마당 사이트는 다음 각 호에 해당하는 이용계약에 대하여는 가입을 취소할 수 있습니다.
① 다른 사람의 명의를 사용하여 신청하였을 때
② 이용계약 신청서의 내용을 허위로 기재하였거나 신청하였을 때
③ 다른 사람의 기업마당 사이트 서비스 이용을 방해하거나 그 정보를 도용하는 등의 행위를 하였을 때
④ 기업마당 사이트를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우
⑤ 기타 기업마당 사이트가 정한 이용신청요건이 미비 되었을 때

제 6 조 (회원정보 사용에 대한 동의)
회원의 개인정보는 공공기관의 개인정보보호에 관한 법률에 의해 보호됩니다.
기업마당 사이트의 회원 정보는 다음과 같이 사용, 관리, 보호됩니다.
① 개인정보의 사용 : 기업마당 사이트는 서비스 제공과 관련해서 수집된 회원의 신상정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않습니다. 단, 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우, 범죄에 대한 수사상의 목적이 있거나 정보통신윤리 위원회의 요청이 있는 경우 또는 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우, 귀하가 기업마당 사이트에 제공한 개인정보를 스스로 공개한 경우에는 그러하지 않습니다.
② 개인정보의 관리 : 귀하는 개인정보의 보호 및 관리를 위하여 서비스의 개인정보관리에서 수시로 귀하의 개인정보를 수정/삭제할 수 있습니다.
③ 개인정보의 보호 : 귀하의 개인정보는 오직 귀하만이 열람/수정/삭제 할 수 있으며, 이는 전적으로 귀하의 ID와 비밀번호에 의해 관리되고 있습니다.
따라서 타인에게 본인의 ID와 비밀번호를 알려주어서는 안되며, 작업 종료 시에는 반드시 로그아웃 해 주시기 바랍니다.
3. 회원이 본 약관에 따라 이용신청을 하는 것은, 기업마당 사이트가 신청서에 기재된 회원정보를 수집, 이용하는 것에 동의하는 것으로 간주됩니다.

제 7 조 (사용자의 정보 보안)
가입 신청자가 기업마당 사이트 서비스 가입 절차를 완료하는 순간부터 귀하는 입력한 정보의 비밀을 유지할 책임이 있으며, 회원의 ID와 비밀번호를 사용하여 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다.
ID와 비밀번호에 관한 모든 관리의 책임은 회원에게 있으며, 회원의 ID나 비밀번호가 부정하게 사용 되었다는 사실을 발견한 경우에는 즉시 기업마당 사이트에 신고하여야 합니다. 신고를 하지 않음으로 인한 모든 책임은 회원 본인에게 있습니다. 종료하지 아니함으로써 제3자가 귀하에 관한 정보를 이용하게 되는 등의 결과로 인해 발생하는 손해 및 손실에 대하여 기업마당 사이트는 책임을 부담하지 아니합니다.

제 8 조 (서비스의 중지)
기업마당 사이트는 이용자가 본 약관의 내용에 위배되는 행동을 한 경우, 임의로 서비스 사용을 제한 및 중지할 수 있습니다.

제 9 조 (서비스의 변경 및 해지)
기업마당 사이트는 귀하가 서비스를 이용하여 기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않으며, 회원이 본 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관하여는 책임을 지지 않습니다. 의한 손해에 대하여 책임을 부담하지 아니합니다.

제 10 조 (게시물의 저작권)
귀하가 게시한 게시물의 내용에 대한 권리는 귀하에게 있습니다.
기업마당 사이트는 게시된 내용을 사전 통지 없이 편집, 이동할 수 있는 권리를 보유하며, 게시판운영 원칙에 따라 사전 통지 없이 삭제할 수 있습니다.
귀하의 게시물이 타인의 저작권을 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 귀하가 부담하여야 합니다.

제 3 장 의무 및 책임
제 11 조 (기업마당 사이트의 의무)
기업마당 사이트는 회원의 개인 신상 정보를 본인의 승낙없이 타인에게 누설, 배포하지 않습니다. 다만, 전기통신관련법령 등 관계법령에 의하여 관계 국가기관 등의 요구가 있는 경우에는 그러하지 아니합니다.

제 12 조 (회원의 의무)
회원 가입 시에 요구되는 정보는 정확하게 기입하여야 합니다. 또한 이미 제공된 귀하에 대한 정보가 정확한 정보가 되도록 유지, 갱신하여야 하며, 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.
회원은 기업마당 사이트의 사전 승낙 없이 서비스를 이용하여 어떠한 영리행위도 할 수 없습니다.

제 4 장 기타
제 13 조 (양도금지)
회원이 서비스의 이용권한, 기타 이용계약 상 지위를 타인에게 양도, 증여할 수 없습니다.

제 14 조 (손해배상)
기업마당 사이트는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 기업마당 사이트가 고의로 행한 범죄행위를 제외하고 이에 대하여 책임을 부담하지 아니합니다.

제 15 조 (면책조항)
기업마당 사이트는 회원이나 제3자에 의해 표출된 의견을 승인하거나 반대하거나 수정하지 않습니다. 기업마당 사이트는 어떠한 경우라도 회원이 서비스에 담긴 정보에 의존해 얻은 이득이나 입은 손해에 대해 책임이 없습니다. 금전적 거래등과 관련하여 어떠한 책임도 부담하지 아니하고, 회원이 서비스의 이용과 관련하여 기대하는 이익에 관하여 책임을 부담하지 않습니다.

제 16 조 (재판관할)
기업마당 사이트와 이용자 간에 발생한 서비스 이용에 관한 분쟁에 대하여는 대한민국 법을 적용하며, 본 분쟁으로 인한 소는 대한민국의 법원에 제기합니다.
`;

export const PrivacyTxt = `
홈페이지에 개인정보처리방침을 게시하기 위한 양식은 법적으로 정해진 양식은 없지만, 개인정보 보호법 및 관련 규정을 준수하여 작성해야 합니다. 일반적으로 다음 내용들을 포함하는 것이 좋습니다: 개인정보 수집 항목 및 목적, 개인정보 보유 및 이용 기간, 개인정보 제3자 제공 현황, 정보주체의 권리 및 행사 방법, 개인정보 보호를 위한 기술적/관리적 조치, 개인정보 관련 문의 및 처리 절차 등. 
자세한 내용:
1. 개인정보 수집 및 이용 목적:
어떤 목적으로 개인정보를 수집하는지 구체적으로 명시해야 합니다. (예: 회원 가입, 서비스 제공, 마케팅 활용 등).
수집하는 개인정보 항목 (예: 이름, 연락처, 이메일 주소, 주소 등)을 항목별로 명확히 해야 합니다.
각 항목별 수집 목적을 명시해야 합니다. 
2. 개인정보 보유 및 이용 기간:
수집한 개인정보를 언제까지 보유하고 이용할 것인지 명시해야 합니다. (예: 회원 탈퇴 시까지, 관련 법령에서 정하는 기간까지).
개인정보 보유 기간이 만료된 후에는 지체 없이 파기해야 함을 명시해야 합니다.
파기 방법 (예: 전자적 파일 삭제, 종이 문서 파쇄 등)도 함께 명시하는 것이 좋습니다. 
3. 개인정보 제3자 제공:
개인정보를 제3자에게 제공하는 경우, 제공받는 자, 제공 목적, 제공하는 개인정보 항목 등을 명시해야 합니다.
사전에 정보주체의 동의를 받지 않고는 개인정보를 제3자에게 제공하지 않아야 합니다.
예외적으로 법령에 따라 제공해야 하는 경우, 그 근거 법령을 명시해야 합니다. 
4. 정보주체의 권리 및 행사 방법:
개인정보 열람, 정정, 삭제, 처리 정지 등을 요구할 수 있는 권리가 있음을 명시해야 합니다.
각 권리 행사 방법을 구체적으로 안내해야 합니다 (예: 온라인 신청, 서면 신청, 유선 문의 등). 
5. 개인정보 보호를 위한 기술적/관리적 조치:
개인정보를 안전하게 보호하기 위해 어떤 기술적 조치(예: 암호화, 접근 통제 등)와 관리적 조치(예: 교육, 정책 수립 등)를 취하고 있는지 명시해야 합니다. 
개인정보 침해 발생 시 신고 절차 및 구제 방법 등을 안내해야 합니다. 
6. 개인정보 관련 문의 및 처리 절차:
개인정보 관련 문의를 할 수 있는 연락처 (예: 담당 부서, 이메일 주소, 전화번호 등)를 명시해야 합니다.
문의 접수 및 처리 절차를 안내해야 합니다. 
참고:
개인정보보호위원회에서 제공하는 개인정보 처리방침 관련 자료 및 예시 양식을 참고할 수 있습니다. 
사이트 특성에 따라 추가적인 내용 (예: 위치정보 처리 방침, 영상정보처리기기 운영 방침 등)을 포함할 수 있습니다. 
개인정보처리방침은 주기적으로 검토하고 필요시 업데이트해야 합니다. 

`;

export const MarketingTxt = `
귀하는 개인(신용)정보의 선택적인 수집∙이용, 제공에 대한 동의를 거부할 수 있습니다. 다만, 동의하지 않을 경우 관련 편의제공(이벤트 안내, 공지사항, 할인행사)안내 등 이용 목적에 따른 혜택에 제한이 있을 수 있습니다.
그 밖에 계약과 관련된 불이익은 없습니다. 동의한 경우에도 귀하는 동의를 철회하거나 마케팅 목적으로 귀하에게 연락하는 것을 중지하도록 요청할 수 있습니다.

1. 수집 및 이용목적
고객에 대한 편의제공, 귀사 및 제휴업체의 상품·서비스 안내 및 이용권유, 사은·판촉행사 등의 마케팅 활동, 시장조사 및 상품·서비스 개발연구 등을 목적으로 수집·이용

2. 수집 및 이용항목
- 개인식별정보: 성명, 성별, 나이, 휴대전화번호, e-mail 등
- 고객 ID, 접속 일시, IP주소 등

3. 보유기간
동의일로부터 회원 탈퇴 혹은 마케팅 동의 해제 시까지 보유·이용
※ 더 자세한 내용에 대해서는 개인정보처리방침을 참고하시기 바랍니다.
`;

export const PolicyDiv = () => {
  return (
    <>
      <div className="page-body">
        <div>
          <h2>
            <strong>
              유탑소프트(이하 ‘회사’), 기억의 서랍 서비스 이용약관
            </strong>
          </h2>
          <p>
            기억의 서랍을 이용하시기 전, 다음 약관과 개인정보 처리방침을 잘
            읽어보시기 바랍니다. 이 약관은 회원 가입시 고지되어 이용자로부터
            동의를 받습니다. 이용약관은 (주)유탑소프트와 사용자 사이에서
            이루어집니다.
          </p>
          <p></p>
          <p>
            <strong>제 1조 (목적)</strong>
          </p>
          <p>
            이 약관은 회사의 서비스 기억의 서랍의 이용과 관련하여 회사와 회원
            간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로
            합니다.
          </p>
          <p></p>
          <p>
            <strong>제 2조 (용어 정의)</strong>
          </p>
          <p>① 이 약관에서 사용하는 정의는 다음과 같습니다.</p>
          <p>
            1. "회원"이라 함은 웹 또는 모바일 앱에서 본 약관에 동의하고 회원
            가입을 한 자를 의미합니다.{" "}
          </p>
          <p>
            2. "서비스"라 함은 회사가 기억의 서랍 앱, 웹을 통해 제공하는 모든
            인터뷰 콘텐츠 및 서비스 일체를 의미합니다.
          </p>
          <p>
            3. "유료서비스"란 회사가 회원에게 제공하는 서비스 중 서비스 이용의
            대가로 요금이 과금되는 서비스를 의미합니다.
          </p>
          <p>
            4. "단말기"라 함은 스마트폰 또는 태블릿 PC 등 앱을 설치하여 구동할
            수 있는 모바일 디바이스를 의미합니다.
          </p>
          <p>
            5. "계정(ID)"이라 함은 회원의 식별과 모바일 서비스 이용을 위하여
            회원이 선정하고 회사가 부여하는 문자, 숫자 또는 특수문자의 조합을
            의미합니다. 또는, 카카오톡 등의 플랫폼사업자가 제공하는 본인 식별을
            위한 ID, 전자우편주소 등의 정보를 계정으로 사용할 수 있습니다.
          </p>
          <p>
            6. "계정정보"라 함은 이름, 휴대폰 번호 등 회원이 회사에 제공한
            일반정보 및 서비스 이용정보, 이용요금 결제상태 등 생성정보를
            통칭합니다. 단, 회원이 1항의 5.의 플랫폼사업자가 제공하는 ID또는
            전자우편주소를 계정으로 선정할 경우, 플랫폼사업자가 제공하는
            고유식별번호(특별한 숫자 또는 문자로 이루어짐)가 계정정보에
            포함됩니다. (예. TID, UID, 앱센터ID 등)
          </p>
          <p>
            7. "오픈마켓"이란 회원이 앱을 유료 또는 무료로 다운받을 수 있도록
            회사와 회원 간의 거래를 중개하는 공간을 말합니다. (예: 애플
            앱스토어, 구글플레이 앱스토어, 네이버 앱스토어, 티스토어 등)
          </p>
          <p>
            8. "앱내부콘텐츠"란 앱내부결제를 통하여 회원이 구매할 수 있는 인터뷰
            콘텐츠 기능 등을 말합니다.
          </p>
          <p></p>
          <p>
            ② 이 약관에서 사용하는 용어의 정의는 제1항 각 호에서 정하는 것을
            제외하고는 관계법령 및 기타 일반적인 상관례에 의합니다.
          </p>
          <p></p>
          <p>
            <strong>제 3조 (약관의 효력 및 적용과 변경)</strong>
          </p>
          <p>
            ① 이 약관은 회사에서 운영하는 기억의 서랍 앱, 웹 내에 공시함으로써
            효력이 발생합니다. 또한, 회사의 앱을 다운로드 받아 콘텐츠 및
            서비스를 이용하는 경우 이 약관에 동의한 것으로 봅니다. 약관에 동의한
            시점부터 약관의 적용을 받고 약관의 변경이 있을 경우에는 변경의
            효력이 발생한 시점부터 변경된 약관의 적용을 받습니다.
          </p>
          <p>
            ② 이 약관에 동의하는 것은 정기적으로 모바일 앱 또는 웹사이트의 이용
            약관 페이지를 방문하여 약관의 변경사항을 확인하는 것에 동의하는 것을
            의미합니다.
          </p>
          <p>
            ③ 회사는 필요하다고 인정되는 경우 이 약관을 변경할 수 있습니다.
            회사는 약관이 변경되는 경우에 변경된 약관의 내용과 적용일을 정하여,
            그 적용일로부터 7일 전 앱내에 공시합니다. 다만,회원에게 불리하게
            약관 내용을 변경하는 경우에는 적용일로부터 30일 전 모바일 서비스
            접속 시 확인할 수 있게 공지합니다. 변경된 약관은 공시하거나 고지한
            적용일로부터 효력이 발생합니다.
          </p>
          <p>
            ④ 회원은 변경된 약관에 대해 거부할 권리가 있습니다. 본 약관의 변경에
            대해 이의가 있는 회원은 서비스 이용을 중단하고 이용계약을
            해지(회원탈퇴)할 수 있습니다. 회원이 변경된 이용약관의 적용일
            이후에도 서비스를 계속 이용하는 경우에는 변경된 약관에 동의한 것으로
            봅니다.
          </p>
          <p></p>
          <p>
            <strong>제 4조 (서비스의 이용개시)</strong>
          </p>
          <p>
            ① 회사는 회원이 이용신청을 승낙한 때부터 서비스를 개시합니다. 단,
            일부 서비스의 경우에는 회사의 필요에 따라 지정된 일자부터 서비스를
            개시할 수 있습니다.
          </p>
          <p>
            ② 회사의 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는
            경우에는 모바일 앱 실행 시 회원에게 이를 통지합니다.
          </p>
          <p></p>
          <p>
            <strong>제 5조 (서비스 제공)</strong>
          </p>
          <p>① 회사는 회원에게 아래와 같은 서비스를 제공합니다.</p>
          <ul>
            <li>음성인식 기술을 이용한 인터뷰 및 스토리북 작성 서비스</li>
          </ul>
          <p>
            ② 회사는 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일
            24시간 서비스 제공을 원칙으로 합니다. 다만, 시스템 정기점검, 서버의
            증설 및 교체, 새로운 콘텐츠의 추가, 각종 버그 패치, 새로운
            서비스로의 교체 등 운영상 필요한 경우, 일정 시간 또는 기간 동안
            서비스를 일시 중지시킬 수 있으며, 관련 법령 상 또는 서비스의 내용 및
            운영상 필요한 경우, 1일 특정 시간 동안에만 서비스를 제공할 수
            있습니다. 위와 같은 경우 회사는 사전에 그 내용 및 시간을 홈페이지
            또는 개별 서비스 관련 홈페이지에 공지합니다.다만, 회사가 사전에
            통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
          </p>
          <p>③ 회사는 서비스를 유료로 제공할 수 있습니다.</p>
          <p>
            ④ 회사는 서비스를 제공 함에 있어 회원에게 본 약관 외에 별도 서비스별
            약관의 체결을 요구할 수 있습니다. 별도의 약관이 요구되는 서비스는
            회원이 해당 앱의 약관에 동의한 후 이용신청을 하고 그러한 내용에 대해
            회사가 승인 함으로써 이용할 수 있습니다.
          </p>
          <p>
            ⑤ 회사는 회원에게 서비스를 제공함에 있어 관련 법령, 회원의 연령,
            서비스의 이용 절차에 따라 일부 서비스 이용 등을 제한할 수 있습니다.
            이 경우 회사는 그 내용을 모바일 앱, 웹 내에서 사전에 안내합니다.
          </p>
          <p>
            ⑥ 만 14세 이상이셔야 가입 및 이용하실 수 있습니다. 기억의 서랍
            회원가입은 만 14세 이상이란 걸 확인하신 것으로 간주됩니다.
          </p>
          <p></p>
          <p>
            <strong>제 6조 (개인정보의 보호 및 사용)</strong>
          </p>
          <p>
            ① 회사는 관계법령이 정하는 바에 따라 회원 등록정보를 포함한 회원의
            개인정보를 보호하기 위해 노력합니다. 회원 개인정보의 보호 및 사용에
            대해서는 관련법령 및 회사의 개인정보취급방침이 적용됩니다.단, 회사의
            공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보취급방침이
            적용되지 않습니다.
          </p>
          <p>
            ② 회사는 본인확인을 위해 필요한 경우, 회원에게 그 이유(용도)를
            고지하고 회원의 신분증 또는 이에 갈음하는 증서를 요구할 수 있습니다.
            회사는 이를 미리 고지한 목적 이외로 사용할 수 없으며, 목적 달성 시
            즉시 재생이 불가능한 방법으로 파기합니다.
          </p>
          <p>
            ③ 회사는 회원의 귀책사유로 인해 노출된 회원의 계정정보를 비롯한 모든
            정보에 대해서 일체의 책임을 지지 않습니다.
          </p>
          <p></p>
          <p>
            <strong>제 7조 (개인정보의 관리 및 변경)</strong>
          </p>
          <p>
            회원은 본 서비스의 이용을 위해 자신의 개인정보를 성실히 관리해야
            하며 개인정보에 변동사항이 있을 경우 이를 변경해야 합니다. 회원의
            개인정보변경이 지연되거나 누락되어 발생되는 손해는 회원의 책임으로
            합니다.
          </p>
          <p></p>
          <p>
            <strong>제 8조 (콘텐츠의 이용)</strong>
          </p>
          <p>
            ① 회원은 이용권 구매 후 이용권에 따라 정해진 기간 내에 주어진 인터뷰
            콘텐츠를 진행할 수 있습니다. 또한 인터뷰 결과 텍스트 및 이미지를
            수정하거나, 인터뷰 내용을 삭제하고 다시 인터뷰를 진행할 수 있습니다.
            동일한 주제에 대한 인터뷰 삭제 및 인터뷰 다시 하기 기능은 99회로
            제한합니다.
          </p>
          <p>
            ② 회원은 정해진 기간 내에 인터뷰 콘텐츠를 완료한 후 전자책 (pdf
            파일) 만들기를 요청할 수 있습니다. 회원은 정해진 기간 내 완성된
            전자책 텍스트 및 이미지를 수정할 수 있습니다.
          </p>
          <p>
            ③ 실물책 배송 옵션이 포함된 이용권을 구매한 회원은 전자책 신청 후
            실물책 인쇄를 신청하여 실물책을 배송받을 수 있습니다. 회원은 실물책
            신청 전 전자책 단계에서 오타 및 내용에 대한 검수를 해야 하며, 이후
            내용 수정은 불가합니다.
          </p>
          <p></p>
          <p>
            <strong>제 9조 (서비스 변경 및 중지)</strong>
          </p>
          <p>
            ① 회사는 운영상 또는 기술상의 필요에 따라 제공하고 있는 서비스를
            변경할 수 있습니다. 변경될 서비스의 내용 및 제공일자 등에 대해서는
            운영하는 홈페이지에 게시하여 사전에 통지합니다. 단, 회사가 사전에
            통지할 수 없는 치명적인 버그 발생, 서버기기결함, 긴급 보안문제 해결
            등의 부득이한 사정이 있는 경우는 사후에 통지할 수 있습니다.
          </p>
          <p>
            ② 회사는 서비스의 기획이나 운영상 또는 회사의 긴박한 상황 등에 의해
            서비스 전부를 중단할 필요가 있는 경우 30일 전에 홈페이지에 이를
            공지하고 서비스의 제공을 중단할 수 있습니다. 회원은 서비스 종료 시
            사용 기간이 남아 있지 않은 유료 서비스에 대하여 배상을 청구할 수
            없습니다.{" "}
          </p>
          <p>
            ③ 회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를
            제한하거나 중지할 수 있습니다.
          </p>
          <p>
            1. 전시, 사변, 천재지변 또는 국가비상사태 등 불가항력적인 사유가
            있는 경우
          </p>
          <p>
            2. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스
            이용에 지장이 있는 경우
          </p>
          <p>3. 서비스용 설비의 보수 등 공사로 인한 부득이한 경우</p>
          <p>4. 회사의 제반 사정으로 서비스를 할 수 없는 경우</p>
          <p>
            ④ 제2항에 의한 서비스 중단의 경우에는 모바일 앱 실행 시 안내문구를
            게시하여 통지합니다. 다만, 회사가 통제할 수 없는 사유로 인한
            서비스의 중단으로 인하여 사전 통지가 불가능한 경우에는 그러하지
            아니합니다.
          </p>
          <p>
            ⑤ 회사는 서비스의 변경 및 중지로 발생하는 문제에 대해서는 책임을
            지지 않습니다.
          </p>
          <p></p>
          <p>
            <strong>제 10조 (정보의 수집)</strong>
          </p>
          <p>
            ① 회사는 모바일 서비스 운영 및 프로그램 안정화 등 모바일 서비스 품질
            개선을 위하여 회원 모바일 단말기 설정 및 사양 정보를 수집•활용할 수
            있습니다.
          </p>
          <p></p>
          <p>
            <strong>제 11조 (회사의 의무)</strong>
          </p>
          <p>
            ① 회사는 관련 법령을 준수하고, 이 약관이 정하는 권리의 행사와 의무의
            이행을 신의에 따라 성실하게 합니다.
          </p>
          <p>
            ② 회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보 보호를
            위해 보안시스템을 구축하며 개인정보취급방침을 공시하고 준수합니다.
            회사는 이 약관 및 개인정보취급방침에서 정한 경우를 제외하고는 회원의
            개인정보가 제3자에게 공개 또는 제공되지 않도록 합니다.
          </p>
          <p>
            ③ 회사는 계속적이고 안정적인 서비스의 제공을 위하여 서비스 개선을
            하던 중 설비에 장애가 생기거나 데이터 등이 멸실 된 때에는 천재지변,
            비상사태, 현재의 기술로는 해결이 불가능한 결함 및 장애 등 부득이한
            사유가 없는 한 지체 없이 이를 수리 또는 복구하도록 최선의 노력을
            다합니다.
          </p>
          <p>
            ④ 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정될
            경우에는 즉시 처리합니다. 다만,즉시 처리가 곤란한 경우에는 회원에게
            사전에 동의 받아 수집한 전화나 전자우편으로 그 사유와 처리일정을
            통보할 수 있습니다.
          </p>
          <p></p>
          <p>
            <strong>제 12조 (회원의 의무)</strong>
          </p>
          <p>① 회원은 다음 행위를 하여서는 안 됩니다.</p>
          <p>
            1. 이벤트 당첨 등으로 인해 회사에 개인정보 제공 시 실명이 아닌 정보
            또는 다른 사람의 정보를 사용하거나, 허위 사실 기재
          </p>
          <p>2. 다른 회원의 ID 및 비밀번호를 도용, 부정하게 사용</p>
          <p>
            3. 회사의 서비스 또는 서비스를 이용하여 얻은 정보를 회사의 사전 승낙
            없이 복제, 유통, 조장하거나 상업적으로 이용
          </p>
          <p>
            4. 회사의 서비스를 이용하여 자기 또는 타인에게 재산상의 이익을 발생
          </p>
          <p>5. 타인의 명예를 훼손하거나 손해를 가하는 행위</p>
          <p>
            6. 명의자의 동의나 승낙 없이 결제 수단을 무단 도용하여
            서비스이용요금을 결제
          </p>
          <p>
            7. 회사의 지적재산권, 제3자의 지적재산권, 초상권 등 기타 권리를 침해
          </p>
          <p>
            8. 회사의 승인을 받지 않고 다른 회원의 개인정보를 수집, 저장, 유포,
            게시
          </p>
          <p>
            9. 프로그램의 버그를 악용하거나 서비스와 관련된 설비의 오동작이나
            정보 등의 파괴 및 혼란을 유발시키는 바이러스 감염자료를 등록 또는
            유포
          </p>
          <p>
            10. 회사 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을
            방해할 수 있는 정보 및 수신자의 명시적인 수신거부 의사에 반하여
            광고성 정보를 전송
          </p>
          <p>11. 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시</p>
          <p>
            12. 음란, 저속한 정보를 교류, 게재하거나 음란사이트를
            연결(링크)하거나 승인되지 않은 광고 및 홍보물 게재
          </p>
          <p>
            13. 재물을 걸고 도박하는 등 사행 행위를 유도하거나 참여하는 경우
          </p>
          <p>
            14. 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나
            화상 또는 영상을 상대방에게 전송, 도달, 유포
          </p>
          <p>15. 서비스에 게시된 정보를 변경하는 행위</p>
          <p>
            16. 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(모바일
            프로그램) 또는 모바일 소프트웨어, 하드웨어, 전기통신 장비의 정상적인
            가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스,기타 다른
            악성 코드, 파일, 프로그램을 포함하고 있는 자료를 전송, 게시, 유포,
            사용
          </p>
          <p>
            17. 회사의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의 명의를
            도용하여 글을 게시하거나 메일을 발송하는 행위
          </p>
          <p>
            18. 기타 공공질서 및 미풍양속을 위반하거나 불법적, 부당한 행위 및
            관계법령에 위배되는 행위
          </p>
          <p>
            ② 회원은 이 약관의 규정, 이용안내 및 모바일 서비스와 관련하여 공지한
            주의사항, 회사가 통지하는 사항 등을 확인하고 준수할 의무가 있습니다.
          </p>
          <p>
            ③ 회사는 제1항, 제2항 및 다음 각 호의 어느 하나에 해당하는 행위의
            구체적인 유형을 운영정책에서 정할 수 있으며, 회원은 이를 준수할
            의무가 있습니다.
          </p>
          <p>1.서비스 이용 방법에 대한 제한</p>
          <p>
            2.기타 회원의 모바일 서비스 이용에 대한 본질적 권리를 침해하지 않는
            범위 내에서 회사가 모바일 서비스 운영상 필요하다고 인정되는 사항
          </p>
          <p></p>
          <p>
            <strong>제 13조 (저작권의 귀속 및 이용제한)</strong>
          </p>
          <p>
            ① 서비스 내 회사가 제작한 콘텐츠에 대한 저작권 및 기타 지적재산권은
            회사의 소유입니다.
          </p>
          <p>
            ② 회원이 서비스 내에 녹음, 업로드한 텍스트 및 이미지에 대한 저작권은
            해당 게시물의 저작자에게 귀속됩니다.
          </p>
          <p>
            ③ 회원은 회사가 제공하는 모바일 서비스를 이용함으로써 얻은 정보 중
            회사 또는 제공업체에 지적재산권이 귀속된 정보를 회사 또는 제공업체의
            사전승낙 없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여
            영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
          </p>
          <p>
            ④ 회원은 앱 내에서 보여지거나 모바일 서비스와 관련하여 회원 또는
            다른 이용자가 모바일 서비스를 통해 업로드 또는 전송하는 대화
            텍스트를 포함한 커뮤니케이션, 이미지, 사운드 및 모든 자료 및
            정보(이하'이용자 콘텐츠')에 대하여 회사가 다음과 같은 방법과
            조건으로 이용하는 것을 허락합니다.
          </p>
          <p>
            1. 해당 이용자 콘텐츠를 이용, 편집 형식의 변경 및 기타 변형하는
            것(공표, 복제, 공연, 전송, 배포, 방송, 2차적 저작물 작성 등 어떠한
            형태로든 이용 가능하며, 이용기간과 지역에는 제한이 없음)
          </p>
          <p>
            2. 이용자 콘텐츠를 제작한 이용자의 사전 동의 없이 거래를 목적으로
            이용자 콘텐츠를 판매, 대여, 양도 행위를 하지 않음
          </p>
          <p>
            3. 제6항은 회사가 모바일 서비스를 운영하는 동안 유효하며 회원탈퇴
            후에도 지속적으로 적용됩니다.
          </p>
          <p></p>
          <p>
            <strong>제 14조 (유료서비스와 유료회원)</strong>
          </p>
          <p>
            ① 회사가 회원의 이용신청을 승낙한 때(신규 및 일부 서비스의 경우,
            이용 신청 접수 후 사전 공지한 지정된 일자)로부터 유료서비스는
            개시되며, 회사의 기술적 사유 등 기타 사정에 의하여 서비스를 개시할
            수 없는 경우에는 제8조의 방법에 따라 회원에게 사전 공지합니다.
          </p>
          <p>
            ② 회사는 회원의 이용신청이 있게 되는 경우, 그 사실을 통지하며,
            회사의 통지를 받은 회원은 의사표시의 불일치 등이 있는 경우 불일치
            사실을 정정 또는 수정을 요청하여야 하며, 회사는 회원의 요청에 따라
            처리하여야 합니다. 다만, 이미 대금을 지불한 경우에는 청약 철회 등에
            관한 제18조의 규정에 따릅니다.
          </p>
          <p>
            ③ 회사는 다음 각 호와 같은 유료서비스를 제공하며, 회사의 사정, 기타
            제반 여건에 따라 서비스 내용을 추가하거나 변경할 수 있습니다. 각
            유료서비스의 내용은 서비스 내 해당 유료서비스 구매페이지에서
            회원에게 자세히 표시하고 있습니다.
          </p>
          <p>
            1. 전자책 스토리북 서비스 : 회원이 음성 인터뷰를 통해 자신의
            이야기를 녹음하면, 이를 기반으로 회사가 전자책 형태의 스토리북을
            제작하여 제공하는 서비스입니다. 완성된 스토리북은 디지털 파일로
            제공되며, 실물 인쇄는 포함되지 않습니다.
          </p>
          <p>
            2. 전자책 및 실물책 스토리북 서비스 : 회원이 음성 인터뷰를 통해
            자신의 이야기를 녹음하면, 이를 기반으로 회사가 스토리북을 제작하여
            전자책 파일과 실물책(인쇄본) 형태로 함께 제공하는 서비스입니다.
          </p>
          <p>
            ④ 회사는 스토리북 외의 기타 콘텐츠나 부가서비스가 함께 제공되는
            결합상품, 다른 회사와의 계약을 통한 제휴 상품 등을 제공할 수
            있습니다.
          </p>
          <p>
            ⑤ 회사와 콘텐츠를 제공하는 개인, 단체, 법인(이하 ‘권리자 등’이라
            합니다) 간의 계약의 체결 여부 및 개별 계약의 내용, ‘권리자 등’의
            사후 요청에 따라 개별 유료서비스 이용이 제한되거나 이용 조건이 사전
            또는 사후 변경될 수 있습니다.
          </p>
          <p></p>
          <p>
            <strong>제 15조 (회원의 유료서비스 상품 변경)</strong>
          </p>
          <p>
            ① 회원이 이미 구매•가입한 유료서비스 내지 상품은 원칙적으로 변경
            처리가 되지 않습니다.
          </p>
          <p>
            ② 회사는 유료서비스 상품에 대한 변경이 있게 될 경우, 이 약관 제8조가
            정하는 방법에 따라 그 사실 및 내용, 변경일자를 사전에 고지합니다.
          </p>
          <p></p>
          <p>
            <strong>제 16조 (대금결제)</strong>
          </p>
          <p>
            콘텐츠에 대한 구매 대금은 원칙적으로 이동통신사와 오픈마켓, 모바일
            앱에서 정하는 방법, 정책 등에 따라 부과되며 납부 방법 역시 정해진
            방법에 따라 납부합니다. 회사의 정책 및 결제업체(이동통신사, 오픈마켓
            스토어, 애플리케이션 스토어 등)의 정책, 정부의 방침 등에 따라 각
            결제 수단별로 결제 한도가 부여될 수 있습니다.
            <br />
          </p>
          <p>
            <strong>제 17조 (청약 철회 및 구매 대금의 환불)</strong>
          </p>
          <p>
            본 환불 정책은 "전자상거래등에서의소비자보호에관한법률(이하
            "전자상거래법")", "소비자분쟁해결기준(공정거래위원회고시)",
            "소비자기본법" 등 관련 법령을 따릅니다.
          </p>
          <p>
            ① 상품의 유형, 상품 이용 상태, 환불 신청일 기준 남은 이용 기간에
            따른 환불 규정은 다음과 같습니다. 이용 기간은 상품별로 상이하며,
            구매시 상품 구매 페이지에서 확인할 수 있습니다.
          </p>
          <table>
            <tbody>
              <tr>
                <td>상품 유형</td>
                <td>상품 이용 상태</td>
                <td>환불 신청일</td>
                <td>환불 금액</td>
              </tr>
              <tr>
                <td>a. 전자책 제공 상품</td>
                <td>전자책 생성 전</td>
                <td>이용 기간 7일 이내</td>
                <td>전액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/3 경과 전</td>
                <td>실 결제금액의 2/3에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/2 경과 전</td>
                <td>실 결제금액의 1/2에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/2 경과 후</td>
                <td>환불 불가</td>
              </tr>
              <tr>
                <td></td>
                <td>전자책 생성 완료</td>
                <td>기간 무관</td>
                <td>환불 불가</td>
              </tr>
              <tr>
                <td>b. 전자책+실물책 제공 상품</td>
                <td>전자책 생성 전</td>
                <td>이용 기간 7일 이내</td>
                <td>전액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/3 경과 전</td>
                <td>실 결제금액의 2/3에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/2 경과 전</td>
                <td>실 결제금액의 1/2에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/2 경과 후</td>
                <td>실 결제금액의 1/4에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td>전자책 생성 완료</td>
                <td>이용 기간 내</td>
                <td>실 결제금액의 1/4에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td>실물책 신청 후</td>
                <td>기간 무관</td>
                <td>환불 불가</td>
              </tr>
            </tbody>
          </table>
          <p>② 선물용 쿠폰 환불 규정은 다음과 같습니다.</p>
          <p>
            1. 선물용 쿠폰은 상품을 등록할 수 있는 코드 형태로 발급됩니다.
            회원은 쿠폰 코드 등록 후 상품을 이용할 수 있습니다.
          </p>
          <p>
            2. 쿠폰 등록 가능 기간 내 쿠폰 코드를 등록하지 않은 경우 전액 환불
            가능합니다. (쿠폰 등록 가능 기간은 구매시 구매 페이지에서 확인할 수
            있습니다.)
          </p>
          <p>3. 쿠폰 등록 가능 기간 경과 후에는 환불 불가합니다.</p>
          <p>
            4. 쿠폰 코드 등록 후에는 상품 유형(a. 전자책 제공 상품 또는 b.
            전자책+실물책 제공 상품)에 따라 일반 상품과 동일하게 환불 규정이
            적용됩니다.
          </p>
          <p>
            <mark>
              <mark>
                ③ 실물책 상품의 교환, 반품, A/S(이하 "교환 등") 관련 규정은
                아래와 같습니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                1. 실물책 옵션이 포함된 상품을 구매한 회원은 실물책 상품에
                중대한 하자를 발견하였을 경우, 해당 상품을 수령한날로부터 7일
                이내에 회사에게 교환 등을 신청할 수 있습니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                2. 다음의 경우는 불량으로 간주되지 않으며, 교환 등의 대상에
                해당하지 않습니다.
              </mark>
            </mark>
          </p>
          <ul>
            <li>
              <mark>
                <mark>텍스트 내용의 오타, 띄어쓰기, 잘못된 이름 등의 사유</mark>
              </mark>
            </li>
          </ul>
          <ul>
            <li>
              <mark>
                <mark>
                  회원이 업로드한 이미지의 해상도 부족으로 인한 화질 저하 등
                  인쇄 품질 관련 사유
                </mark>
              </mark>
            </li>
          </ul>
          <ul>
            <li>
              <mark>
                <mark>
                  ※ 전자책 제작 단계에서 표지 및 본문 텍스트, 이미지를 확인 및
                  수정한 후 최종 인쇄를 신청해야 하며, 이로 인한 교환/반품은
                  불가합니다.
                </mark>
              </mark>
            </li>
          </ul>
          <p>
            <mark>
              <mark>
                3. 불량 및 오배송에 의한 교환, 반품, A/S는 상품 수령일로부터 7일
                이내에 전화, 전자우편, 앱 내 1:1 문의 등의 방법으로 신청해야
                합니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                4. 회사는 사용자에게 하자 판단을 위한 증빙 자료 등을 요구할 수
                있으며, 구매자가 이에 협조하지 않을 경우 교환 등의 진행이 불가할
                수 있습니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                5. 교환 등을 진행하게 될 경우, 불량 서비스 또는 상품의 회수
                여부는 회사가 결정합니다. 사용자가 해당 결정에 따르기를 거부하는
                것은 교환 등의 요청 자체를 철회하는 것으로 간주합니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                6. 배송 상태가 배송 완료로 확인되나 실제로는 상품을 수령하지
                못하였을 경우, 구매자는 배송 완료일 기준 7 영업일 이내(해외 배송
                건의 경우 배송 완료일 기준 1달 이내)에 판매자에게 문의를
                접수하여야 합니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                7. 불량, 오배송 등이 인정된 상품의 교환 등 처리 과정에서
                발생하는 비용은 회사가 부담합니다.
              </mark>
            </mark>
          </p>
          <p>
            ④ 청약 철회는 회원이 전화, 전자우편, 앱 내 1:1 문의 등의 방법으로
            회사에 의사를 표시하여 회사에 도달될 때 그 효력이 발생하며, 회사는
            회원의 의사표시를 수령한 후 지체 없이 이러한 사실을 회원에게
            회신합니다.
          </p>
          <p>
            ⑤ 회사는 회원이 청약 철회, 해지•해제 신청을 확인 후 환불 금액이 있을
            경우, 원칙적으로 회원의 해당 의사표시를 수령한 날로부터 3영업일
            이내에 결제수단 별 사업자에게 대금의 청구 정지 내지 취소를 요청하고,
            회원이 결제한 동일 결제수단으로 환불함을 원칙으로 합니다. 단, 회사가
            사전에 회원에게 공지한 경우 및 아래의 각 경우와 같이 개별 결제
            수단별 환불 방법, 환불 가능 기간 등이 차이가 있을 수 있습니다.{" "}
          </p>
          <p>
            1. 신용카드 등 수납 확인이 필요한 결제수단의 경우에는 수납
            확인일로부터 5 영업일 이내
          </p>
          <p>
            2. 결제수단 별 사업자가 회사와의 약정을 통하여 사전에 대금 청구 정지
            내지 결제 취소 가능 기한 등을 미리 정하여 둔 경우로 해당 기한을 지난
            환불의 경우
          </p>
          <p>
            3. 회원이 유료서비스/ 상품의 이용 결과, 얻은 이익이 있거나 중도
            해지의 경우
          </p>
          <p>
            4. 회원이 환불 처리에 필요한 정보 내지 자료를 회사에 즉시 제공하지
            않는 경우 (현금 환불 시 신청인의 계좌 및 신분증 사본을 제출하지
            아니하거나, 타인 명의의 계좌를 제공하는 경우 등)
          </p>
          <p></p>
          <p>
            <strong>제 18조 (계약해지 및 서비스 이용중지)</strong>
          </p>
          <p>
            ① 회원은 회사가 제공하는 유료서비스 이용 시 관계법령, 이 약관,
            세부이용지침, 서비스 이용안내 및 사이트 내 공지한 주의사항, 회사가
            서비스 이용과 관련하여 회원에게 통지하는 사항 등을 준수하여야 하며,
            기타 회사 및 타인의 명예를 훼손하거나 서비스 운영 기타 업무수행에
            지장을 초래하는 행위를 해서는 안됩니다.
          </p>
          <p>
            ② 회원은 ID 및 비밀번호를 관리할 책임이 있으며, 본인이 아닌 타인이
            사용하게 하여서는 안됩니다. 회원의 개인정보를 타인이 사용하여
            유료서비스를 이용함으로써 발생한 결과에 대한 책임은 회원에게
            있습니다. 회원은 타인의 명의, ID, 비밀번호, 휴대폰번호, 계좌번호,
            신용카드번호 등 개인정보를 도용하거나 부정하게 사용하여서는
            안됩니다.
          </p>
          <p>
            ③ 회원은 회사가 사전에 허용한 경우를 제외하고는 유료서비스를
            영업활동 등 영리목적으로 이용하거나 이 약관에서 금지하는 행위를
            하거나 허용하는 범위를 벗어난 이용행위를 하여서는 안됩니다.
          </p>
          <p>
            ④ 회원은 유료서비스 이용과정에서 위법행위 또는 선량한 풍속 기타
            사회질서에 반하는 행위를 하여서는 아니 되며, 제3자와 유상으로
            거래하거나 현금으로 전환하는 행위를 하여서는 안됩니다.
          </p>
          <p>
            ⑤ 회원은 유료서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이
            서비스의 이용 이외의 목적으로 사용하여서는 안됩니다.
          </p>
          <p>
            ⑥ 회원은 서비스 관련 각종 콘텐츠 및 자료 등을 사적 이용 범위
            내에서만 사용하여야 하고 제3자에게 제공하거나 영리를 목적으로 사용할
            수 없습니다. 또한 음성서비스를 녹음하거나 다운로드 받은 콘텐츠 등을
            불법적으로 유포, 공유하여서는 안되며, 이를 위반하여 발생한 제반
            문제에 대한 책임은 회원 본인에게 있습니다.
          </p>
          <p>
            ⑦ 회사는 제1항에서 제6항까지의 회원의 위반 행위가 있는 경우 해당
            회원에 대하여 위반 사실을 고지하고 서비스 제공을 1개월간
            정지시키거나 서비스 이용계약을 해제 또는 해지할 수 있습니다. 본 항의
            회사의 의사표시는 회원에게 표시한 날로부터 효력이 발생합니다. 한편,
            회사의 해제•해지 및 이용 정지에 대하여 회원은 회사가 정한 절차에
            따라 이의신청할 수 있으며, 회원의 이의가 정당하다고 회사가 인정하는
            경우 회사는 서비스의 이용을 재개할 수 있습니다.
          </p>
          <p>
            ⑧ 유료서비스 이용과 관련하여 진실한 정보를 입력하지 않은 회원은
            법적인 보호를 받을 수 없으며, 서비스 이용에 제한을 받을 수 있습니다.
          </p>
          <p></p>
          <p>
            <strong>제 19조 (개인정보 수집과 이용)</strong>
          </p>
          <p>유탑소프트는 개인정보의 안전한 처리에 최선을 다합니다.</p>
          <ul>
            <li>
              필수정보인 개인정보 수집 이용 및 동의를 거부할 수 있습니다. 단,
              필수정보는 서비스 제공을 위하여 필요한 최소한의 개인정보이므로
              동의를 해주셔야 서비스 이용이 가능합니다.
            </li>
          </ul>
          <ul>
            <li>
              선택정보인 개인정보 수집 이용 및 동의를 거부할 수 있으며, 회원의
              선택에 따라 기재하지 않아도 됩니다.
            </li>
          </ul>
          <ul>
            <li>
              서비스 이용 과정에서 IP 주소, 쿠키, 서비스 이용 기록, 기기정보,
              운영체제 버전, 통신사 네트워크망 이름, 앱버전이 생성되어 수집될 수
              있습니다.
            </li>
          </ul>
          <ul>
            <li>
              더 자세한 내용은{" "}
              <a href="https://www.notion.so/24603dc3d92c80b89b87c3b7686c2908?pvs=21">
                개인 정보 처리 방침
              </a>
              을 확인해 주세요.
            </li>
          </ul>
          <p></p>
          <p>
            <strong>제 20조 (손해배상)</strong>
          </p>
          <p>
            ① 회사가 고의 또는 중과실로 회원에게 손해를 끼친 경우, 손해에 대하여
            배상할 책임이 있습니다.
          </p>
          <p>
            ② 회원이 본 약관을 위반하여 회사에 손해를 끼친 경우, 회원은 회사에
            대하여 그 손해에 대하여 배상할 책임이 있습니다.
          </p>
          <p></p>
          <p>
            <strong>제 21조 (회사의 면책)</strong>
          </p>
          <p>
            ① 회사는 다음 각 호의 사유로 인하여 회원 또는 제3자에게 발생한
            손해에 대하여는 그 책임을 지지 아니합니다.
          </p>
          <p>
            1. 천재지변 또는 이에 준하는 불가항력으로 인해 유료서비스를 제공할
            수 없는 경우
          </p>
          <p>2. 회원이 자신의 ID 또는 비밀번호 등의 관리를 소홀히 한 경우</p>
          <p>
            3. 회사의 관리영역이 아닌 공중통신선로의 장애로 서비스이용이
            불가능한 경우
          </p>
          <p>4. 서비스 관련 제휴사 등 제3자의 고의/과실로 인한 경우</p>
          <p>5. 기타 회사의 귀책사유가 없는 통신서비스 등의 장애로 인한 경우</p>
          <p>
            ② 회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것,
            서비스에 게시된 게시물에 대한 취사 선택 또는 이용으로 발생하는 손해
            등에 대해서는 책임을 지지 않습니다. 또한 회원이 사이트에 띄어 게재한
            리뷰, 평점 등 게시물의 정확성 등 내용에 대하여는 책임을 지지
            않습니다.
          </p>
          <p>
            ③ 회사는 회원 상호간 또는 회원과 교육 콘텐츠 제공자 등을 포함한
            제3자 상호간에 서비스와 관련하여 발생한 분쟁에 대하여 개입할 의무가
            없으며, 회사에 귀책사유가 없는 한 이로 인하여 발생한 손해를 배상할
            책임이 없습니다.
          </p>
          <p></p>
          <p>
            <strong>제 23조 (회원에 대한 통지)</strong>
          </p>
          <p>
            ① 회사가 회원에게 통지를 하는 경우 회원이 지정한 전자우편주소,
            문자메시지 등으로 할 수 있습니다.
          </p>
          <p>
            ② 회사는 회원 전체에게 통지를 하는 경우 7일 이상 앱의 초기화면에
            게시하거나 팝업화면 등을 제시함으로써 제1항의 통지에 갈음할 수
            있습니다.
          </p>
          <p></p>
          <p>
            <strong>제 24조 (약관 외 준칙)</strong>
          </p>
          <p>
            이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는
            「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한
            법률」, 「정보통신망이용촉진 및 정보보호 등에 관한 법률」,
            「콘텐츠산업진흥법」 등 관련 법령에 따릅니다.
          </p>
          <p></p>
          <p>
            <strong>제 25조 (재판권 및 준거법)</strong>
          </p>
          <p>
            본 약관은 대한민국 법률에 따라 규율되고 해석되며, 회사와 회원간에
            발생한 분쟁으로 소송이 제기되는 경우, 법령에 정한 절차에 따른 법원을
            관할 법원으로 합니다.
          </p>
          <p></p>
        </div>
      </div>
    </>
  );
};

export const PrivacyDiv = () => {
  return (
    <>
      <div className={`page-body`}>
        <div>
          <p>
            ‘기억의 서랍’ 서비스 제공자 ㈜유탑소프트(이하 회사)는 이용자의
            개인정보를 중요시하며, 개인정보 보호법 등 관련 법령을 준수합니다.
            유탑은 개인정보처리방침을 통하여 이용자가 제공하는 개인정보가 어떠한
            용도와 방식으로 이용되고 있으며 개인정보 보호를 위해 어떠한 조치가
            취해지고 있는지 알려드립니다.
          </p>
          <h2>
            <strong>수집하는 개인정보의 항목</strong>
          </h2>
          <p>
            <strong>(1) 회원 가입을 위해 필요한 정보</strong>
          </p>
          <ul>
            <li>이메일 (필수)</li>
          </ul>
          <ul>
            <li>휴대폰 번호 (필수)</li>
          </ul>
          <ul>
            <li>이름 (필수)</li>
          </ul>
          <p>
            <strong>(2) 서비스 이용을 위해 필요한 정보</strong>
          </p>
          <ul>
            <li>목소리 녹음 파일, 인터뷰 텍스트, 서비스 이용 기록</li>
          </ul>
          <ul>
            <li>(이미지 업로드 시) 갤러리 접근 권한</li>
          </ul>
          <ul>
            <li>
              (이용자 결제 시) 이용자 거주 국가, 결제 이용 카드 소유주명,
              카드번호, 유효기간, 보안에 필요한 일련번호(CVC 번호 일부)
            </li>
          </ul>
          <ul>
            <li>(선물 구매 시) 선물 받을 사용자의 휴대폰 번호</li>
          </ul>
          <ul>
            <li>(배송 신청 시) 수령인, 수령인의 휴대폰 번호, 배송지</li>
          </ul>
          <p>
            <strong>(3) 서비스 관련 이용 문의 시 필요한 정보</strong>
          </p>
          <ul>
            <li>
              서비스 관련 이용 문의를 하거나, 권리침해 신고를 접수하는 경우에는
              문의 접수 및 해결 과정에서 이메일, SNS 계정, 전화번호
            </li>
          </ul>
          <ul>
            <li>
              모바일의 경우
              <ul>
                <li>
                  단말기 모델, 이동통신사 정보, 하드웨어 ID, 서비스 이용에 대한
                  기본 통계)
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>단말기에 관한 정보</li>
          </ul>
          <h2>
            <strong>개인정보의 수집 및 이용 목적</strong>
          </h2>
          <p>회사는 수집한 정보를 다음과 같은 목적으로 이용합니다.</p>
          <ul>
            <li>서비스 이용에 따른 이용자 식별 및 부정 이용 방지</li>
          </ul>
          <ul>
            <li>이용자의 원활한 서비스 이용</li>
          </ul>
          <ul>
            <li>서비스 이용에 관한 통계 데이터 작성</li>
          </ul>
          <ul>
            <li>맞춤 서비스 제공</li>
          </ul>
          <ul>
            <li>
              이용자로부터 문의가 있을 때 본인 여부를 확인하고 문의사항에
              대응하기 위해
            </li>
          </ul>
          <ul>
            <li>중요한 공지사항 등을 필요에 따라 공지</li>
          </ul>
          <ul>
            <li>
              유료 서비스 제공 과정에서 결제 기능, 본인확인, 결제 내역 관리 등을
              제공
            </li>
          </ul>
          <ul>
            <li>고충처리, 분쟁 조정을 위한 기록 보존</li>
          </ul>
          <ul>
            <li>
              (마케팅 수신 동의 시) 새로운 기능(제품)의 안내, 할인 및 쿠폰 등
              이벤트 등 광고성 정보 제공
            </li>
          </ul>
          <h2>
            <strong>보유기간</strong>
          </h2>
          <p>
            회사는 원칙적으로 이용자의 개인정보를 회원탈퇴 시 혹은
            개인정보처리방침에 명시된 목적의 달성 시 지체없이 파기하고 있습니다.
            다만 법령에서 일정 기간 정보보관 의무를 부과하는 경우에는 해당 기간
            동안 개인정보를 보관합니다(아래 예시 참고).
            <br />
            개인정보의 보유 기간
          </p>
          <table>
            <thead>
              <tr>
                <th>
                  <strong>개인정보 항목</strong>
                </th>
                <th>
                  <strong>보관 기간</strong>
                </th>
                <th>
                  <strong>근거 법령</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>로그인 기록</td>
                <td>3개월</td>
                <td>
                  통신비밀보호법 제15조의2, 동법 시행령 제41조 제2항 제2호
                </td>
              </tr>
              <tr>
                <td>표시 및 광고에 관한 기록</td>
                <td>6개월</td>
                <td>
                  전자상거래 등에서의 소비자보호에 관한 법률 제6조 제3항, 동법
                  시행령 제6조 제1항 제1호
                </td>
              </tr>
              <tr>
                <td>소비자 불만 또는 분쟁처리에 관한 기록</td>
                <td>3년</td>
                <td>
                  전자상거래 등에서의 소비자보호에 관한 법률 제6조 제3항, 동법
                  시행령 제6조 제1항 제4호
                </td>
              </tr>
              <tr>
                <td>계약 또는 청약철회 등에 관한 기록</td>
                <td>5년</td>
                <td>
                  전자상거래 등에서의 소비자보호에 관한 법률 제6조 제3항, 동법
                  시행령 제6조 제1항 제2호
                </td>
              </tr>
              <tr>
                <td>대금결제 및 재화 등의 공급에 관한 기록</td>
                <td>5년</td>
                <td>
                  전자상거래 등에서의 소비자보호에 관한 법률 제6조 제3항, 동법
                  시행령 제6조 제1항 제3호
                </td>
              </tr>
              <tr>
                <td>세법이 규정하는 모든 거래에 관한 장부 및 증빙서류</td>
                <td>5년</td>
                <td>국세기본법 제85조의 3</td>
              </tr>
              <tr>
                <td>통신사실확인자료(전기통신사업법 제83조 제3항)</td>
                <td>12개월</td>
                <td>
                  통신비밀보호법 제15조의2, 동법 시행령 제41조 제2항 제3호
                </td>
              </tr>
            </tbody>
          </table>
          <h2>
            <strong>개인정보 수집방법</strong>
          </h2>
          <p>
            회사는 서비스 제공을 위해 다음과 같은 방법으로 개인정보를
            수집합니다.
          </p>
          <ul>
            <li>서비스의 회원가입 및 이용 과정에서 이용자로부터 직접 수집</li>
          </ul>
          <ul>
            <li>
              소셜 회원가입 및 로그인 과정에서 해당 회원가입 및 로그인 서비스를
              제공하는 SNS(애플, 카카오톡, 구글)로부터 제공받는 방법
            </li>
          </ul>
          <ul>
            <li>전화, 상담 게시판, 이메일을 통한 수집</li>
          </ul>
          <h2>
            <strong>개인정보의 처리위탁</strong>
          </h2>
          <p>
            회사는 원활한 개인정보업무처리를 위하여 다음과 같이 개인정보
            처리업무를 위탁하고 있습니다. 위탁업무의 내용이나 수탁자가 변경될
            경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록
            하겠습니다.
          </p>
          <table>
            <thead>
              <tr>
                <th>수탁 업체명</th>
                <th>위탁 업무의 내용</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>주식회사 카카오</td>
                <td>카카오 비즈니스 채널</td>
              </tr>
              <tr>
                <td>네이버 클라우드</td>
                <td>문자 메세지, 카카오 알림톡 발송</td>
              </tr>
              <tr>
                <td>Open AI</td>
                <td>
                  음성 인식 기능, 실시간 인터뷰 대화 제공, 인터뷰 요약 생성
                </td>
              </tr>
              <tr>
                <td>Claude</td>
                <td>인터뷰 기반 글 생성</td>
              </tr>
              <tr>
                <td>북크크</td>
                <td>실물책 인쇄</td>
              </tr>
              <tr>
                <td>대한통운</td>
                <td>실물책 배송</td>
              </tr>
            </tbody>
          </table>
          <h2>
            <strong>개인정보의 파기</strong>
          </h2>
          <ul>
            <li>
              파기 절차
              <br />
              이용자 개인정보의 처리목적이 달성된 경우 등 그 개인정보가
              불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.
              관계법령의 규정에 따라 개인정보를 파기하지 아니하고 보존하여야
              하는 경우에는 해당 개인정보 또는 개인정보파일을 다른 개인정보와
              분리해서 저장·관리 합니다. 파기 시에는 파기사유가 발생한
              개인정보를 선정하여 개인정보 책임자의 승인을 받아 해당 정보를
              파기합니다.
            </li>
          </ul>
          <ul>
            <li>
              파기 방법
              <br />
              종이에 출력된 개인정보는 분쇄기로 분쇄하고, 전자적 파일 형태로
              저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여
              삭제합니다.
            </li>
          </ul>
          <h2>
            <strong>개인정보의 안전성 확보 조치에 관한 사항</strong>
          </h2>
          <p>
            회사는 이용자들의 개인정보를 처리함에 있어 개인 정보가 분실, 도난,
            유출, 변조 또는 훼손되지 않도록 안전성 확보를 다음과 같은 안전성
            확보조치를 시행하고 있습니다.
          </p>
          <ul>
            <li>
              이용자의 개인정보는 암호화하여 저장·관리되고 있으며, 암호화
              통신(SSL) 등을 통하여 전송하고, 비밀번호는 복호화 불가능하도록
              일방향 암호화하여 저장·관리되고 있습니다.
            </li>
          </ul>
          <ul>
            <li>
              해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가 유출되거나
              훼손되는 것을 막기 위해 외부로부터 접근이 통제된 구역에 시스템을
              설치하고 있습니다.
            </li>
          </ul>
          <ul>
            <li>
              개인정보의 훼손에 대비해서 자료를 수시로 백업하고, 최신
              백신프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나
              손상되지 않도록 방지하고 있으며, 암호화 통신(SSL) 등을 통하여
              네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.
            </li>
          </ul>
          <ul>
            <li>
              침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
              있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든
              기술적 장치를 갖추려고 노력하고 있습니다.
            </li>
          </ul>
          <ul>
            <li>
              개인정보를 처리하는 직원을 최소화 하여 개인정보 유출에 대한 위험을
              줄이고 있습니다.
            </li>
          </ul>
          <ul>
            <li>
              개인정보를 보관하는 데이터베이스 시스템과 개인정보를 처리하는
              시스템에 대한 비밀번호의 생성과 변경, 그리고 접근할 수 있는 권한에
              대한 체계적인 기준을 마련하고 지속적인 감사를 실시하고 있습니다.
            </li>
          </ul>
          <ul>
            <li>
              개인정보를 처리하는 임직원들을 대상으로 개인정보보호 의무와 보안에
              대한 정기적인 교육이나 캠페인을 실시하고 있습니다.
            </li>
          </ul>
          <ul>
            <li>
              개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고
              있습니다.
            </li>
          </ul>
          <h2>
            <strong>
              인터넷 접속정보파일 등 개인정보를 자동으로 수집하는 장치의
              설치ㆍ운영 및 그 거부에 관한 사항
            </strong>
          </h2>
          <p>
            사용자의 정보를 수시로 저장하고 찾아내는 쿠키(cookie)를 사용합니다.
            쿠키는 회사 웹사이트 운영에 이용되는 서버가 사용자의 브라우저에
            보내는 아주 작은 텍스트 파일로, 사용자의 기기내 저장공간에
            저장됩니다.
          </p>
          <p>
            (1) 쿠키 사용 목적
            <br />
            다음과 같은 목적으로 쿠키를 사용합니다.
          </p>
          <ul>
            <li>자동 로그인 기능 구현</li>
          </ul>
          <ul>
            <li>회원/비회원의 접속 빈도 또는 방문 시간 등 분석</li>
          </ul>
          <ul>
            <li>사용자의 취향과 관심분야 파악 및 사용 기록 확인</li>
          </ul>
          <ul>
            <li>
              각종 이벤트 참여 및 방문 횟수 파악 등을 통한 타겟 마케팅과 개인
              맞춤 서비스 제공 등
            </li>
          </ul>
          <p>
            (2) 쿠키 설정 방법
            <br />
            사용자는 쿠키를 설치할 것인지 선택할 수 있습니다. 사용 중인
            웹브라우저의 설정 메뉴에서 쿠키 허용 수준을 변경하거나, 모든 쿠키의
            저장을 거부(예: 인터넷 익스플로러 11.0 : 도구 &gt; 인터넷옵션 &gt;
            개인정보)할 수 있습니다. 단, 사용자가 쿠키 설치를 거부할 경우 일부
            서비스가 제공되지 않을 수 있습니다.
          </p>
          <h2>
            <strong>개인정보 보호책임자의 명칭과 연락처</strong>
          </h2>
          <ul>
            <li>이름: 김상수</li>
          </ul>
          <ul>
            <li>직위: 이사</li>
          </ul>
          <ul>
            <li>
              이메일:{" "}
              <a href="mailto:sooskim@utopsoft.co.kr">sooskim@utopsoft.co.kr</a>
            </li>
          </ul>
          <p>
            이용자는 기억의 서랍의 서비스를 이용하면서 발생한 모든 개인정보 보호
            관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보보호책임자 및
            담당부서로 문의할 수 있습니다. 기억의 서랍은 이용자의 문의에 대해
            지체 없이 답변 및 처리해드릴 것입니다.
          </p>
          <p></p>
          <p>
            추가적으로 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래
            기관에 문의하시기 바랍니다.
          </p>
          <p>
            개인정보침해신고센터(
            <a href="http://privacy.kisa.or.kr/">http://privacy.kisa.or.kr</a>/
            국번없이 118)
          </p>
          <p>
            대검찰청 사이버수사과(
            <a href="http://www.spo.go.kr/">http://www.spo.go.kr</a>/ 국번없이
            1301)
          </p>
          <p>
            경찰청 사이버안전국(
            <a href="http://cyberbureau.police.go.kr/">
              http://cyberbureau.police.go.kr
            </a>
            / 국번없이 182)
          </p>
          <p></p>
          <h2>
            <strong>개인정보 처리방침의 변경 및 고지</strong>
          </h2>
          <p>
            현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소
            7일 전부터 홈페이지의 ‘공지사항’을 통해 고지할 것입니다. 또한
            개인정보 보호정책에 버전번호 및 변경공고일자 및 그 시행일자 등을
            부여하여 개정여부를 쉽게 알 수 있도록 하고 있습니다.
          </p>
        </div>
      </div>
    </>
  );
};

export const RefundDiv = () => {
  return (
    <>
      <div className={`page-body`}>
        <div>
          <p>
            본 환불 정책은 &quot;전자상거래등에서의소비자보호에관한법률(이하
            &quot;전자상거래법&quot;)&quot;,
            &quot;소비자분쟁해결기준(공정거래위원회고시)&quot;,
            &quot;소비자기본법&quot; 등 관련 법령을 따릅니다.
          </p>
          <p>
            ① 상품의 유형, 상품 이용 상태, 환불 신청일 기준 남은 이용 기간에
            따른 환불 규정은 다음과 같습니다. 이용 기간은 상품별로 상이하며,
            구매시 상품 구매 페이지에서 확인할 수 있습니다.
          </p>
          <table>
            <tbody>
              <tr>
                <td>상품 유형</td>
                <td>상품 이용 상태</td>
                <td>환불 신청일</td>
                <td>환불 금액</td>
              </tr>
              <tr>
                <td>a. 전자책 제공 상품</td>
                <td>전자책 생성 전</td>
                <td>이용 기간 7일 이내</td>
                <td>전액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/3 경과 전</td>
                <td>실 결제금액의 2/3에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/2 경과 전</td>
                <td>실 결제금액의 1/2에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/2 경과 후</td>
                <td>환불 불가</td>
              </tr>
              <tr>
                <td></td>
                <td>전자책 생성 완료</td>
                <td>기간 무관</td>
                <td>환불 불가</td>
              </tr>
              <tr>
                <td>b. 전자책+실물책 제공 상품</td>
                <td>전자책 생성 전</td>
                <td>이용 기간 7일 이내</td>
                <td>전액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/3 경과 전</td>
                <td>실 결제금액의 2/3에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/2 경과 전</td>
                <td>실 결제금액의 1/2에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 1/2 경과 후</td>
                <td>실 결제금액의 1/4에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td>전자책 생성 완료</td>
                <td>이용 기간 내</td>
                <td>실 결제금액의 1/4에 해당하는 금액 환불</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>이용 기간 경과 후</td>
                <td>환불 불가</td>
              </tr>
              <tr>
                <td></td>
                <td>실물책 신청 후</td>
                <td>기간 무관</td>
                <td>환불 불가</td>
              </tr>
            </tbody>
          </table>
          <p>② 선물용 쿠폰 환불 규정은 다음과 같습니다.</p>
          <p>
            1. 선물용 쿠폰은 상품을 등록할 수 있는 코드 형태로 발급됩니다.
            회원은 쿠폰 코드 등록 후 상품을 이용할 수 있습니다.
          </p>
          <p>
            2. 쿠폰 등록 가능 기간 내 쿠폰 코드를 등록하지 않은 경우 전액 환불
            가능합니다. (쿠폰 등록 가능 기간은 구매시 구매 페이지에서 확인할 수
            있습니다.)
          </p>
          <p>3. 쿠폰 등록 가능 기간 경과 후에는 환불 불가합니다.</p>
          <p>
            4. 쿠폰 코드 등록 후에는 상품 유형(a. 전자책 제공 상품 또는 b.
            전자책+실물책 제공 상품)에 따라 일반 상품과 동일하게 환불 규정이
            적용됩니다.
          </p>
          <p></p>
          <p>
            <mark>
              <mark>
                ③ 실물책 상품의 교환, 반품, A/S(이하 &quot;교환 등&quot;) 관련
                규정은 아래와 같습니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                1. 실물책 옵션이 포함된 상품을 구매한 회원은 실물책 상품에
                중대한 하자를 발견하였을 경우, 해당 상품을 수령한날로부터 7일
                이내에 회사에게 교환 등을 신청할 수 있습니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                2. 다음의 경우는 불량으로 간주되지 않으며, 교환 등의 대상에
                해당하지 않습니다.
              </mark>
            </mark>
          </p>
          <ul>
            <li>
              <mark>
                <mark>텍스트 내용의 오타, 띄어쓰기, 잘못된 이름 등의 사유</mark>
              </mark>
            </li>
          </ul>
          <ul>
            <li>
              <mark>
                <mark>
                  회원이 업로드한 이미지의 해상도 부족으로 인한 화질 저하 등
                  인쇄 품질 관련 사유
                </mark>
              </mark>
            </li>
          </ul>
          <ul>
            <li>
              <mark>
                <mark>
                  ※ 전자책 제작 단계에서 표지 및 본문 텍스트, 이미지를 확인 및
                  수정한 후 최종 인쇄를 신청해야 하며, 이로 인한 교환/반품은
                  불가합니다.
                </mark>
              </mark>
            </li>
          </ul>
          <p>
            <mark>
              <mark>
                3. 불량 및 오배송에 의한 교환, 반품, A/S는 상품 수령일로부터 7일
                이내에 전화, 전자우편, 앱 내 1:1 문의 등의 방법으로 신청해야
                합니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                4. 회사는 사용자에게 하자 판단을 위한 증빙 자료 등을 요구할 수
                있으며, 구매자가 이에 협조하지 않을 경우 교환 등의 진행이 불가할
                수 있습니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                5. 교환 등을 진행하게 될 경우, 불량 서비스 또는 상품의 회수
                여부는 회사가 결정합니다. 사용자가 해당 결정에 따르기를 거부하는
                것은 교환 등의 요청 자체를 철회하는 것으로 간주합니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                6. 배송 상태가 배송 완료로 확인되나 실제로는 상품을 수령하지
                못하였을 경우, 구매자는 배송 완료일 기준 7 영업일 이내(해외 배송
                건의 경우 배송 완료일 기준 1달 이내)에 판매자에게 문의를
                접수하여야 합니다.
              </mark>
            </mark>
          </p>
          <p>
            <mark>
              <mark>
                7. 불량, 오배송 등이 인정된 상품의 교환 등 처리 과정에서
                발생하는 비용은 회사가 부담합니다.
              </mark>
            </mark>
          </p>
          <p></p>
          <p>
            ④ 청약 철회는 회원이 전화, 전자우편, 앱 내 1:1 문의 등의 방법으로
            회사에 의사를 표시하여 회사에 도달될 때 그 효력이 발생하며, 회사는
            회원의 의사표시를 수령한 후 지체 없이 이러한 사실을 회원에게
            회신합니다.
          </p>
          <p></p>
          <p>
            ⑤ 회사는 회원이 청약 철회, 해지•해제 신청을 확인 후 환불 금액이 있을
            경우, 원칙적으로 회원의 해당 의사표시를 수령한 날로부터 3영업일
            이내에 결제수단 별 사업자에게 대금의 청구 정지 내지 취소를 요청하고,
            회원이 결제한 동일 결제수단으로 환불함을 원칙으로 합니다. 단, 회사가
            사전에 회원에게 공지한 경우 및 아래의 각 경우와 같이 개별 결제
            수단별 환불 방법, 환불 가능 기간 등이 차이가 있을 수 있습니다.{" "}
          </p>
          <p>
            1. 신용카드 등 수납 확인이 필요한 결제수단의 경우에는 수납
            확인일로부터 5 영업일 이내
          </p>
          <p>
            2. 결제수단 별 사업자가 회사와의 약정을 통하여 사전에 대금 청구 정지
            내지 결제 취소 가능 기한 등을 미리 정하여 둔 경우로 해당 기한을 지난
            환불의 경우
          </p>
          <p>
            3. 회원이 유료서비스/ 상품의 이용 결과, 얻은 이익이 있거나 중도
            해지의 경우
          </p>
          <p>
            4. 회원이 환불 처리에 필요한 정보 내지 자료를 회사에 즉시 제공하지
            않는 경우 (현금 환불 시 신청인의 계좌 및 신분증 사본을 제출하지
            아니하거나, 타인 명의의 계좌를 제공하는 경우 등)
          </p>
          <p></p>
        </div>
      </div>
    </>
  );
};

export const guideList: any = [
  {
    step: 1, //  순서
    orangeYn: "true",
    state: () => {
      return <>인터뷰 진행중</>;
    }, //  진행 상태
    date: `20일 ~ 30일`, //  소요 기간
    desc: () => {
      return <>인터뷰를 모두 완료한 다음 책을 만들 수 있어요</>;
    }, //  실행
  },
  {
    step: 2, //  순서
    state: () => {
      return <>전자책 신청</>;
    }, //  진행 상태
    date: `1분`, //  소요 기간
    desc: () => {
      return (
        <>
          인터뷰 완료 후 전자책 만들기를 신청해 주세요
          <br />
          <span>책 신청 후에는 개별 인터뷰를 추가, 삭제, 수정할 수 없어요</span>
        </>
      );
    }, //  실행
  },
  {
    step: 3, //  순서
    state: () => {
      return <>전자책 생성중</>;
    }, //  진행 상태
    date: `5분`, //  소요 기간
    desc: () => {
      return <></>;
    }, //  실행
  },
  {
    step: 4, //  순서
    orangeYn: "true",
    state: () => {
      return <>전자책 생성 완료</>;
    }, //  진행 상태
    date: ``, //  소요 기간
    desc: () => {
      return <>책 안의 이미지와 내용을 확인하고 직접 수정할 수 있어요</>;
    }, //  실행
  },
  {
    step: 5, //  순서
    orangeYn: "true",
    state: () => {
      return (
        <>
          실물책 신청
          <br />
          <span style={{ color: "black" }}>(프리미엄 요금제만 해당)</span>
        </>
      );
    }, //  진행 상태
    date: `2분`, //  소요 기간
    desc: () => {
      return (
        <>
          전자책 내용 확인 후, 실물책 신청을 해주세요
          <br />
          <span>
            실물 책 신청 후에는 신청 내용을 취소하거나 수정할 수 없어요
          </span>
        </>
      );
    }, //  실행
  },
  {
    step: 6, //  순서
    state: () => {
      return <>편집중</>;
    }, //  진행 상태
    date: `6영업일`, //  소요 기간
    desc: () => {
      return <>전자책을 인쇄가 가능하도록 편집 작업을 진행할게요</>;
    }, //  실행
  },
  {
    step: 7, //  순서
    state: () => {
      return <>인쇄중</>;
    }, //  진행 상태
    date: `5영업일`, //  소요 기간
    desc: () => {
      return <></>;
    }, //  실행
  },
  {
    step: 8, //  순서
    state: () => {
      return <>배송중</>;
    }, //  진행 상태
    date: `3영업일`, //  소요 기간
    desc: () => {
      return <></>;
    }, //  실행
  },
  {
    step: 9, //  순서
    state: () => {
      return <>배송 완료</>;
    }, //  진행 상태
    date: ``, //  소요 기간
    desc: () => {
      return <></>;
    }, //  실행
  },
];
export const useWarnBeforeUnload = (isDirty: boolean) => {
  useEffect(() => {
    if (!isDirty) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ""; // 표준 방식: 내용은 무시되지만 경고창 트리거
      // window.confirm("돌아가시겠습니까?");
    };
    window.addEventListener("popstate", handler);
    return () => window.removeEventListener("popstate", handler);
  }, [isDirty]);
};

export const useConfirmOnBack = (enabled: boolean, message: string) => {
  console.log(enabled, "/[enabled]");
  useEffect(() => {
    if (!enabled) return;

    const sentinel = { __block__: Date.now() };

    // 현재 URL로 더미 히스토리 1칸 추가 (사용자 눈엔 동일한 URL)
    window.history.pushState(sentinel, "");

    const onPop = () => {
      window.history.pushState(sentinel, "");
    };

    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      // 언마운트 시 더미 스택을 굳이 정리(back)하지 않는 편이 깔끔합니다.
    };
  }, [enabled, message]);
};
